import { Drawer, useMobileMediaQuery } from '@iheartjane/reefer';
import { useEffect, useRef, useState } from 'react';

import { useEcommApp } from '@jane/shared/providers';
import { postMessageToIframeParent } from '@jane/shared/util';

import { useCustomerDispatch } from '../../../customer/dispatch';
import { closeCart, selectCart } from '../../../customer/redux/cart';
import { useCustomerSelector } from '../../../customer/selectors';
import { useResizeIframe } from '../../../hooks/useResizeIframe';
import { CartAlerts } from '../../cartAlerts';
import { CartReferenceContainer } from './cartDrawer/cartDrawer.styles';
import { CartDrawerContainer } from './cartDrawer/cartDrawerContainer';

export const EmbeddedCartDrawer = ({
  container,
}: {
  container?: string | HTMLElement;
}) => {
  const hasBeenOpened = useRef(false);

  const isMobile = useMobileMediaQuery({});
  const dispatch = useCustomerDispatch();
  const { appMode } = useEcommApp();

  const [showCartAlerts, setShowCartAlerts] = useState<boolean>(false);

  const {
    cart: { is_open },
    isLoading: isCartLoading,
  } = useCustomerSelector(selectCart);
  const isCartOpen = !!is_open;

  const janeDrawerRef = useRef<HTMLDivElement>(null);

  const { registerResizer, unregisterResizer } = useResizeIframe(
    janeDrawerRef,
    { isModal: true, autoRegister: false }
  );

  useEffect(() => {
    if (isCartOpen) {
      if (!hasBeenOpened.current) {
        hasBeenOpened.current = true;
      }
      postMessageToIframeParent({
        messageType: 'saveScrollPosition',
      });
      // This allows the drawer to shrink the iframe to a smaller size than the contentHeightMap (show.js.erb)
      postMessageToIframeParent({
        messageType: 'enableShrinkEveryResize',
      });
      postMessageToIframeParent({
        messageType: 'scrollToTop',
      });
      registerResizer();
    }

    if (!isCartOpen && hasBeenOpened) {
      postMessageToIframeParent({
        messageType: 'disableShrinkEveryResize',
      });

      const app = document.getElementById('app');
      if (app) {
        postMessageToIframeParent({
          messageType: 'resizeIFrame',
          payload: app.scrollHeight,
        });
      }
      postMessageToIframeParent({
        messageType: 'restoreScrollPosition',
        payload: 'smooth',
      });
    }

    return () => unregisterResizer();
  }, [isCartOpen]);

  const handleClose = () => {
    dispatch(closeCart());
  };

  return (
    <Drawer
      background="grays-ultralight"
      container={container}
      fitScreen={false}
      onRequestClose={handleClose}
      open={isCartOpen}
      width={isMobile ? '95vw' : '540px'}
    >
      <CartReferenceContainer
        ref={janeDrawerRef}
        height={isCartLoading ? '100vh' : 'auto'}
      >
        <CartDrawerContainer setShowCartAlerts={setShowCartAlerts} />
        {showCartAlerts && appMode !== 'default' && (
          <CartAlerts
            onClose={() => setShowCartAlerts(false)}
            isCheckoutAlert
          />
        )}
      </CartReferenceContainer>
    </Drawer>
  );
};
